module.exports = __webpack_public_path__ + "sunsemweb/img/book.84888daa.png";